import { render, staticRenderFns } from "./ProfessionalsDiagram.vue?vue&type=template&id=46fa771c&scoped=true&"
import script from "./ProfessionalsDiagram.vue?vue&type=script&lang=js&"
export * from "./ProfessionalsDiagram.vue?vue&type=script&lang=js&"
import style0 from "./ProfessionalsDiagram.vue?vue&type=style&index=0&id=46fa771c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fa771c",
  null
  
)

export default component.exports